<template>
  <div>
      Create password after confirmation code verification
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Session/Signup/Step2.vue